import { ReactNode } from 'react';

import { Root } from './styles';

interface PipHeaderProps {
  className?: string;
  children: ReactNode;
}

const PipHeader = ({ className, children }: PipHeaderProps) => {
  return <Root className={className}>{children}</Root>;
};

export default PipHeader;
